<template>
  <div>
    <custom-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :productType="productType"
      :titleObj="titleObj"
    >
    </custom-header>
    <custom-center></custom-center>
    <custom-footer
      :bottomNews="bottomNews"
      :bottom="bottom"
      :bottomInfo="bottomInfo"
      :productType="productType"
    >
    </custom-footer>
  </div>
</template>
<script>
import CustomHeader from "@/components/pc/Header";
import CustomCenter from "@/components/pc/CustomCenter";
import CustomFooter from "@/components/pc/Footer";
export default {
  name: "Custom",
  data() {
    return {
      screenStyle: {
        width: "",
        margin: "0 auto",
      },
      topStyle: "",
      actIndex: 1,
      imgList: [],
      logo: "",
      productType: [],
      bottom: {},
      bottomInfo: {},
      bottomNews: [],
      background: require("../../static/images/custom_develop/banner.png"),
      titleObj: {},
    };
  },
  components: {
    CustomHeader,
    CustomCenter,
    CustomFooter,
  },
  mounted() {
    this.Pc_Mobile();
    this.getPageData();
    this.getHeaderImage();
    this.titleObj = {
      title: "软件研发",
      desc: "专属定制永久使用 一匠提供应用软件开发与企业信息化建设服务，\n将IT与业务需求统一起来，能够帮助客户实现商业成功",
    };
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_custom");
      } else {
        this.$router.push("/custom");
      }
    },
    getPageData() {
      this.$http.post("home/index/product", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;
        // this.topStyle = "background-image:url('" + this.background + "')";
        this.bottomInfo = res.data.contact[0];
        this.productType = res.data.type;
        this.productAll = res.data.product;
        this.bottomNews = res.data.b_news;
      });
    },
    getHeaderImage() {
      this.$http.post("https://eartisanapplets.wsandos.com/api/index/special", {type_two:1}, (res) => {
        //  console.log(res,'qwuioiquwe')
        if (res.code == 1) {
          this.topStyle =
            "background-image:url('" + res.data.pc_image + "')";
        }
        // console.log(res.data,'qwuioiquwe')
      });
    },
  },
};
</script>
<style lang="stylus" scoped></style>


// WEBPACK FOOTER //
// src/views/pc/Custom.vue